import { connect } from 'react-redux';

import Admin from './component';

import {
  AddedCandidates,
  AddedElections,
  AddedRaces,
  FlaggedLinks,
  FlaggedTopics,
  NationalTopics,
} from './components';

import { getAuthTokenFromStorage, getUserIdFromStorage } from '../../utils';

const mapStateToProps = (state) => {
  const {
    user: {
      user,
    },
  } = state;

  const isAdmin = !!user.is_admin;
  const isLoggedIn = !!(Object.keys(user).length > 0 && getUserIdFromStorage() && getAuthTokenFromStorage());

  return {
    isAdmin,
    isLoggedIn,
    user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Admin);

export {
  AddedCandidates,
  AddedElections,
  AddedRaces,
  FlaggedLinks,
  FlaggedTopics,
  NationalTopics,
};
